// The preferences feature's own copy, added to the app's i18next resources.
import { i18next } from '../../shared/i18n/i18n'
import cs from './preferences.cs.json'
import en from './preferences.en.json'

i18next.addResourceBundle('en', 'translation', en, true)
i18next.addResourceBundle('cs', 'translation', cs, true)
